import axios, { AxiosHeaders } from 'axios';

import { APIUrlGenerator } from '@/lib/helper';

import { API_ROUTES } from '@/constant/routes';
import StoreModel from '@/models/store.model';

import { DEFAULT_PAGE_LIMIT } from './type';

export async function getStoreList(store: string, offset: number) {
  const {
    data: { payload },
    headers,
  }: { data: { payload: StoreModel }; headers: AxiosHeaders } = await axios.get(
    APIUrlGenerator(API_ROUTES.GET_STORE_LIST(store), {
      'per-page': DEFAULT_PAGE_LIMIT,
      page: offset,
    }),
  );

  // Convert Axios headers into a plain object
  const plainHeaders = {
    'x-pagination-total-count': headers['x-pagination-total-count'],
  };
  return { payload, headers: plainHeaders };
}
